export type MeasurementPlanEventType =
  | 'mvp_plan_analysis_started'
  | 'mvp_plan_preview_generated'
  | 'mvp_plan_email_submitted'
  | 'mvp_plan_confluence_copied'
  | 'mvp_plan_md_downloaded'
  | 'mvp_plan_human_review_requested';

const VISITOR_STORAGE_KEY = 'hestia_visitor_id';

function getVisitorId(): string {
  if (typeof window === 'undefined') {
    return 'server';
  }

  const existing = window.localStorage.getItem(VISITOR_STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const created = `visitor_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
  window.localStorage.setItem(VISITOR_STORAGE_KEY, created);
  return created;
}

export function trackMeasurementPlanEvent(
  type: MeasurementPlanEventType,
  payload: { path: string; lang: 'fr' | 'en' }
) {
  if (typeof window === 'undefined') {
    return;
  }

  void fetch('/api/analytics/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      type,
      visitorId: getVisitorId(),
      path: payload.path,
      title: document.title,
      referrer: document.referrer || null,
      label: payload.lang,
    }),
    keepalive: true,
  });
}
